var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 12.18a5.15 5.15 0 0 0-.04-1.1c-.07-.99-.23-3.83-1.23-5.56C16.13 3.4 12.81 2.02 11 2c-1.8.02-5.12 1.4-6.33 3.52-1 1.73-1.16 4.57-1.23 5.56a4.93 4.93 0 0 0-.05 1.1c.05 5.44-1.46 5.24-1.4 6.42.04.65.73 1.04 2.28 1.27 1.06.22 3.52.11 4.28.04v-1.68c.8.43 1.62.65 2.44.65H11c.82 0 1.65-.22 2.45-.65v1.68c.75.07 3.21.18 4.27-.04 1.56-.23 2.24-.62 2.28-1.27.06-1.18-1.44-.98-1.4-6.43zm-1.09 1.01c-.21.38-.69.24-.78.24h-.06l-.31-.03-.14.3c-.85 2-2.85 4.13-5.21 4.13H11c-2.37 0-4.36-2.14-5.22-4.13l-.13-.3-.31.02h-.07c-.09 0-.57.14-.78-.23a3.57 3.57 0 0 1-.2-1.75c1.56-.1 4.73-.56 6.43-2.15.08-.08.15-.14.28-.15.13 0 .2.07.29.15 1.7 1.6 4.87 2.06 6.43 2.15a3.6 3.6 0 0 1-.21 1.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFemale);
export default ForwardRef;